import Slider from '../components/Slider';

const defaults = {
  wrapAround: true,
  pageDots: true,
  prevNextButtons: false,
  autoPlay: false,
  adaptiveHeight: false,
  groupCells: 1,
};

export default class Pods {
  constructor(element) {
    this.element = element;
    this.settings = defaults;
    this.Slider = new Slider(this.container, this.settings);
    this.ready();
  }

  ready() {
    this.element.classList.add('ready');
  }

  get container() {
    return this.element.querySelector('.block-content');
  }
}
